import { useState } from "react";
import { useForm } from "react-hook-form";
import api from '../../../services/api';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import PageContainer from '../../../common/components/PageContainer';
import useAlerta from '../../../common/components/useAlerta';
import AppSnackbar from '../../../common/components/AppSnackbar';

function CadastroEPI() {
  const { register, handleSubmit, reset } = useForm();
  const { alerta, mostrarAlerta, fecharAlerta } = useAlerta();
  const [imageData, setImageData] = useState(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      convertToBase64(file);
    }
  };

  const convertToBase64 = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setImageData(reader.result);
    };
    reader.onerror = (error) => {
      console.error('Erro ao converter a imagem para Base64:', error);
    };
  };

  const onSubmit = async (data) => {
    if (!imageData) {
      console.error('Nenhuma imagem foi selecionada.');
      return;
    }

    const formData = {
      ...data,
      foto: imageData,
    };

    try {
      await api.post('/epi', formData);
      mostrarAlerta('EPI cadastrado com sucesso!', 'success');
      setTimeout(() => {
        window.location.href = '/epi';
      }, 1500);
    } catch (error) {
      mostrarAlerta('Erro ao cadastrar EPI!', 'error');
      reset();
      setImageData(null);
    }
    setTimeout(fecharAlerta, 3000);
  };

  return (
    <PageContainer sx={{ maxWidth: 700 }}>
      <Paper component="form" onSubmit={handleSubmit(onSubmit)} sx={{ p: { xs: 2, sm: 4 } }}>
        <Typography variant="h5" sx={{ color: 'primary.main', fontWeight: 600, mb: 3 }}>
          Cadastro de Item
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <Avatar src={imageData || undefined} variant="rounded" sx={{ width: 96, height: 96, bgcolor: 'primary.light' }}>
            {!imageData && <HealthAndSafetyOutlinedIcon fontSize="large" />}
          </Avatar>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField {...register("nome")} label="Nome" required fullWidth />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField {...register("ca")} label="CA" fullWidth />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField {...register("estoque")} label="Estoque" type="number" required fullWidth />
          </Grid>
          <Grid item xs={12}>
            <Button variant="outlined" component="label" fullWidth>
              Selecionar foto
              <input
                {...register("foto")}
                type="file"
                accept="image/*"
                hidden
                onChange={handleFileChange}
                required
              />
            </Button>
          </Grid>
        </Grid>

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Button type="submit" variant="contained" color="secondary" size="large" sx={{ px: 6 }}>
            Cadastrar
          </Button>
        </Box>
      </Paper>

      <AppSnackbar alerta={alerta} onClose={fecharAlerta} />
    </PageContainer>
  );
}

export default CadastroEPI;
